module.exports = "https://static.wmbcdn.com/uniweb/images/8a6dce0a2ab7634448ae9d3cb736d4a7.svg";